import { css, keyframes } from "styled-components";
import token from "styled-token";
import { spaceMixin } from "../spaceMixin";
import { spacingMixin } from "../spacingMixin";
import { typographyMixin } from "../typographyMixin";
import { StyledPropertyCardBody } from "../../components/PropertyCard/PropertyCardBody";
import { StyledPropertyCardDataArea } from "../../components/PropertyCard/PropertyCardDataArea";
import { StyledPropertyCardDataWrapper } from "../../components/PropertyCard/PropertyCardDataWrapper";
import { StyledPropertyCardMLSFooter } from "../../components/PropertyCard/PropertyCardMLSFooter";
import { StyledPropertyCardPhotoBody } from "../../components/PropertyCard/PropertyCardPhotoBody";
import { StyledGrid } from "../../components/Grid/Grid";
import { StyledText } from "../../components/Text/Text";
import { PROPERTY_CARD_APPEARANCES } from "../../constants/PROPERTY_CARD";

var loadingCSS = function loadingCSS(props) {
  var loading = props.loading;

  if (!loading) {
    return "";
  }

  return token({
    backgroundColor: "PropertyCard.loading.backgroundColor",
    backgroundImage: "PropertyCard.loading.backgroundImage",
    maxCardWidth: "PropertyCard.maxWidth." + PROPERTY_CARD_APPEARANCES.LARGE
  }, function (_ref) {
    var backgroundColor = _ref.backgroundColor,
        backgroundImage = _ref.backgroundImage,
        maxCardWidth = _ref.maxCardWidth;
    var shimmer = /*#__PURE__*/keyframes(["0%{background-position-x:-", "px;}100%{background-position-x:", "px;}"], maxCardWidth, maxCardWidth);
    return css(["", ",", "{background-color:", ";background-size:", "px;background-repeat:no-repeat;background-image:", ";animation-name:", ";animation-duration:1.5s;animation-iteration-count:infinite;}@media (prefers-reduced-motion:reduce){", ",", "{animation:none;}}", "{line-height:1;margin-bottom:", ";&:nth-child(1){width:6em;}&:nth-child(2){width:95%;}&:nth-child(3){width:85%;}&:last-child{margin-bottom:0;}}"], StyledPropertyCardDataArea, StyledPropertyCardPhotoBody, backgroundColor, maxCardWidth, backgroundImage, shimmer, StyledPropertyCardDataArea, StyledPropertyCardPhotoBody, StyledPropertyCardDataArea, spaceMixin("xs")(props));
  });
};

var flagCSS = function flagCSS(props) {
  /* Gives Flag Card a slightly darker shadow because it usually appears over a map */
  var appearance = props.appearance,
      cardElevation = props.cardElevation,
      interactive = props.interactive;

  if (appearance !== PROPERTY_CARD_APPEARANCES.FLAG) {
    return "";
  }

  return token({
    cardBodyBoxShadow: "PropertyCard.cardBody.boxShadow." + PROPERTY_CARD_APPEARANCES.FLAG,
    cardBodyBoxShadowHover: "PropertyCard.cardBody.boxShadow.hover." + PROPERTY_CARD_APPEARANCES.FLAG,
    focusShadow: "shadows.focus",
    width: "PropertyCard.width." + PROPERTY_CARD_APPEARANCES.FLAG
  }, function (_ref2) {
    var cardBodyBoxShadow = _ref2.cardBodyBoxShadow,
        cardBodyBoxShadowHover = _ref2.cardBodyBoxShadowHover,
        focusShadow = _ref2.focusShadow,
        width = _ref2.width;
    return css(["width:", "px;", "{box-shadow:", ";", "}"], width, StyledPropertyCardBody, cardElevation === 1 ? cardBodyBoxShadow : "none", interactive && cardElevation === 1 && css(["&:hover{box-shadow:", ";}&:focus{box-shadow:", ";}&:focus:hover{box-shadow:", ";}&:active{box-shadow:", ";}"], cardBodyBoxShadowHover, cardBodyBoxShadow + ", " + focusShadow, cardBodyBoxShadowHover + ", " + focusShadow, focusShadow));
  })(props);
};
/** @class PropertyCardMixin */

/** @method */


export var PropertyCardMixin = function PropertyCardMixin(props) {
  var appearance = props.appearance,
      cardGridTemplate = props.cardGridTemplate;
  var isVerticalCard = appearance === PROPERTY_CARD_APPEARANCES.LARGE || appearance === PROPERTY_CARD_APPEARANCES.SMALL;
  return token({
    defaultGridTemplate: "PropertyCard.cardBody.gridTemplate." + appearance,
    gridTemplateAreas: "PropertyCard.gridTemplateAreas." + appearance,
    maxWidth: "PropertyCard.maxWidth." + appearance,
    minWidth: "PropertyCard.minWidth." + appearance,
    mlsFontType: "PropertyCard.mls.fontType." + appearance,
    mlsFontWeight: "fontWeights.finePrintHeading"
  }, function (_ref3) {
    var defaultGridTemplate = _ref3.defaultGridTemplate,
        gridTemplateAreas = _ref3.gridTemplateAreas,
        maxWidth = _ref3.maxWidth,
        minWidth = _ref3.minWidth,
        mlsFontType = _ref3.mlsFontType,
        mlsFontWeight = _ref3.mlsFontWeight;
    return css(["height:", ";max-width:", "px;min-width:", "px;", "{display:grid;grid-template-areas:", ";grid-template-", ":", ";height:", ";padding:0;&:hover,&:active{background-color:#fff;}& + ", " > ", "{margin-top:", ";}}", "{padding:", ";}", "{justify-content:", ";", "{", " font-weight:", ";text-align:", ";}}", " ", " ", ""], appearance === PROPERTY_CARD_APPEARANCES.LARGE ? "100%" : "auto", maxWidth, minWidth, StyledPropertyCardBody, gridTemplateAreas, isVerticalCard ? "rows" : "columns", cardGridTemplate || defaultGridTemplate, appearance === PROPERTY_CARD_APPEARANCES.LARGE ? "100%" : "auto", StyledGrid, StyledPropertyCardDataArea, spaceMixin("xs")(props), StyledPropertyCardDataWrapper, appearance === PROPERTY_CARD_APPEARANCES.FLAG ? spaceMixin(0.5)(props) + " " + spaceMixin("xs")(props) : "" + spaceMixin("xs")(props), StyledPropertyCardMLSFooter, appearance === PROPERTY_CARD_APPEARANCES.LARGE ? "end" : "space-between", StyledText, typographyMixin(Object.assign({
      fontColor: "inherit",
      fontType: mlsFontType
    }, props)), mlsFontWeight, appearance === PROPERTY_CARD_APPEARANCES.LARGE ? "right" : "left", flagCSS(props), spacingMixin(props), loadingCSS(props));
  });
};